import Loading from './Loading';

export { Loading };
